import $ from 'jquery';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function getItemCategoryIds() {
    const params = queryString();
    let ids = (params['ids'] || '').split(',');
    if (ids[0] === '' && ids.length === 1) {
      ids = [];
    }
    return new Set(ids);
  }

  function setItemCategoryIds(ids) {
    const params = queryString();
    let url = null;
    params['ids'] = Array.from(ids).join(',');

    if (Object.keys(params).length > 0 && $.param(params).length > 0) {
      url = '?' + $.param(params);
    } else {
      url = window.location.pathname;
    }

    window.history.replaceState(null, '', url);
  }

  function updateItemCategoriesControls() {
    const selectedCheckboxesLength = $('.checkbox--item-categories:checked').length;
    const itemCategoriesCount = $('.data-table__tr').length;
    const totalSelectedItemCategories = getItemCategoryIds().size;

    if (totalSelectedItemCategories) {
      $('.h-d-button__text').text(`(${totalSelectedItemCategories})`);
      $('.h-d-button--delete-item-categories').prop('disabled', false);

      $('.h-s-button--merge-item-categories').prop('disabled', totalSelectedItemCategories <= 1);
      $('.checkbox--item-categories-check-all').prop(
        'checked',
        selectedCheckboxesLength === itemCategoriesCount
      );
    } else {
      $('.h-d-button--delete-item-categories').prop('disabled', true);
      $('.h-s-button--merge-item-categories').prop('disabled', true);
      $('.h-d-button__text').text('');
    }
  }

  $(document).ready(() => {
    getItemCategoryIds().forEach((itemCategoryId) => {
      $(`.data-table__tr[data-id=${itemCategoryId}]`)
        .find('.checkbox--item-categories')
        .prop('checked', true);
    });
    updateItemCategoriesControls();
  });

  $(document).on('change', '.checkbox--item-categories', (e) => {
    const ids = getItemCategoryIds();
    const id = String($(e.target).closest('.data-table__tr').data('id'));
    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    if (checked) {
      ids.add(id);
    } else {
      ids.delete(id);
    }
    const newIds = Array.from(ids).join(',');

    $('.pagination a').each(function (index, link) {
      const url = new URL(link.href);
      const params = parseQuery(url.search);
      params['ids'] = newIds;
      url.search = '?' + $.param(params);
      link.href = url.href;
    });

    setItemCategoryIds(ids);
    updateItemCategoriesControls();
  });

  $(document).on('change', '.checkbox--item-categories-check-all', (e) => {
    $('.checkbox--item-categories').prop('checked', $(e.target).prop('checked')).trigger('change');
    updateItemCategoriesControls();
  });

  $(document).on('click', '.h-d-button--delete-item-categories', (e) => {
    const selectedItemCategoryIds = Array.from(getItemCategoryIds());

    $('.modal--delete-item-categories-confirmation .d-button--confirm-delete').attr(
      'href',
      `/item_categories/delete_item_categories?category_ids=${selectedItemCategoryIds}`
    );
    $('.modal--delete-item-categories-confirmation .modal__header').text(
      `Are you sure you want to delete ${selectedItemCategoryIds.length} selected categories?`
    );

    $('.modal--delete-item-categories-confirmation').modal();
  });

  $(document).on('click', '.h-s-button--merge-item-categories', (e) => {
    // assign a temporary name based on first selected category
    const tmpName = $('.checkbox--item-categories:checked:first')
      .closest('.data-table__tr')
      .find('.data-table__td--name')
      .text()
      .trim();
    $('.field--merge-item-categories').val(tmpName);

    const selectedItemCategoryIds = Array.from(getItemCategoryIds());
    $('#category_ids').val(selectedItemCategoryIds);

    $('.modal--merge-item-categories').modal();
  });

  $(document).on('click', '.item-categories-search-form__clear', (e) => {
    const $el = $(e.target);
    $el.siblings('.item-categories-search-form__field').val('');
    $el.parents('.item-categories-search-form').submit();
  });
});
